/**
 * Whether the job screen is the document workbench: it has documents on screen.
 *
 * App's own copy of a job's batch arrives when a capture's processing answers,
 * but the workspace shows each document the moment the engine reports it done,
 * under a `live:` placeholder batch that never leaves the workspace. Counting
 * only App's copy said "no documents" for the whole of a first read, and App drew
 * a second status bar under the workspace's document bar (2026-09-27). The
 * workspace now reports how many documents it shows, and either source counts.
 */
export function workbenchHasDocuments(
  saved: { readonly documents: readonly unknown[] } | null | undefined,
  shownByWorkspace: number | undefined,
): boolean {
  return (saved?.documents.length ?? 0) > 0 || (shownByWorkspace ?? 0) > 0;
}
